import { render, staticRenderFns } from "./endorsement-extra-benefit-table.vue?vue&type=template&id=3fcb2839&scoped=true&"
import script from "./endorsement-extra-benefit-table.vue?vue&type=script&lang=js&"
export * from "./endorsement-extra-benefit-table.vue?vue&type=script&lang=js&"
import style0 from "./endorsement-extra-benefit-table.vue?vue&type=style&index=0&id=3fcb2839&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcb2839",
  null
  
)

export default component.exports